module.exports = new __parcel__URL__("animation_chip_image.07744ce2.png").toString();